export const txAllocationManagementMenuName = 'Menu::MenuG:TxAllocationManagement';
export const bilateralSchedulesMenuName = 'Menu::MenuG:BilateralSchedules';
export const viewInterconIntervalMenuName = 'Menu::MenuG:InterconIntervalSchedules';
export const scadaInterconeMenuName = 'Menu::MenuG:ScadaInterconEnergyMeasurement';
export const schedVScadaMenuName = 'Menu::MenuG:ScheduledVsScadaMeasurement';
